export interface BookModalChecks {
  errors: string[];
  warnings: string[];
  remarks: string[];
  info: string[];
}

export enum BookModalActionTypes {
  MANUAL_BOOKING = 'MANUAL_BOOKING',
  SEND_REQUEST = 'SEND_REQUEST',
}
